export default __webpack_public_path__ + "static/media/35.e719e65e.jpg";